import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/modules/index.js'
import request from './utils/request.js'
import 'vant/lib/index.css'
// import './assets/styles/global.css'
import './assets/stylus/variable.styl'
import './assets/stylus/base.styl'
import './assets/stylus/common.styl'

// 按需引入 Vant 组件
import { 
  Button, 
  NavBar, 
  Tabbar, 
  TabbarItem,
  Cell, 
  CellGroup,
  Field,
  Form,
  Dialog,
  Toast,
  Icon,
  Swipe, 
  SwipeItem,
  Popup,
  Picker,
  showToast,
  Tab, 
  Tabs,
  Grid, 
  GridItem,
  PasswordInput, 
  NumberKeyboard,
  ShareSheet,
  Empty
} from 'vant'
const app = createApp(App)

// 注册 Vant 组件
app.use(Button)
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Cell)
app.use(CellGroup)
app.use(Field)
app.use(Form)
app.use(Dialog)
app.use(Toast)
app.use(Icon)
app.use(Swipe)
app.use(SwipeItem)
app.use(Popup)
app.use(Picker)
app.use(Tab)
app.use(Tabs)
app.use(Grid)
app.use(GridItem)
app.use(PasswordInput)
app.use(NumberKeyboard)
app.use(ShareSheet)
app.use(Empty)

app.use(router)
app.use(store)

app.config.globalProperties.$showMsg = showToast
app.config.globalProperties.$api = request


app.mount('#app')